goog.provide('el8.util.datecompare');

goog.require('el8.util.consts');
goog.require('el8.service.tz');

el8.util.datecompare = (function() {

    return {

        // Comparison utilities
        cmp: function(a, b) {
            if (a.getTime() > b.getTime()) { return 1; }
            if (a.getTime() < b.getTime()) { return -1; }
            return 0;
        },
        isToday: function(_date) {
            return this.isSameDay(el8.service.tz.today(), _date);
        },
        isAfterToday: function(_date) {
            return !this.isToday(_date) && (_date > el8.service.tz.today());
        },
        isTodayOrAfter: function(_date) {
            return (_date > el8.service.tz.today()) || this.isToday(el8.service.tz.newTzDate(_date));
        },
        isBetween: function(candidate, date1, date2) {
            return candidate >= date1 && candidate <= date2;
        },
        isSameDay: function(date1, date2) {
            return date1.getFullYear() === date2.getFullYear() &&
                date1.getMonth() === date2.getMonth() && 
                date1.getDate() === date2.getDate();
        },
        isSameDayOrLater: function(date1, date2) {
            return this.isSameDay(date1, date2) || (date1 < date2);
        },
        isSameTime: function(time1, time2) {
            return time1.getHours() === time2.getHours() &&
                time1.getMinutes() === time2.getMinutes() &&
                time1.getSeconds() === time2.getSeconds();
        },
        isEqual: function(date1, date2) {
            return date1.getTime() === date2.getTime();
        },
        getWeekOfMonth: function(_date) {
            var day = _date.getDate();
            return Math.ceil(day/7);
        },
        dateFromStr: function(value) {
            // Setting to verify in the form of Date.format
            var formatList = Date.format.split('/');
            var yIndex, mIndex, dIndex;
            for (var i=0;i<formatList.length;i++) {
                if (formatList[i][0].toLowerCase() === "y") {yIndex = i;}
                if (formatList[i][0].toLowerCase() === "m") {mIndex = i;}
                if (formatList[i][0].toLowerCase() === "d") {dIndex = i;}
            }
            
            var d = value.split('/');
            // Make sure date is right number of elements, then pad them
            if (d.length !== 3) {return false;}
            if (d[mIndex].length === 1) {d[mIndex] = '0'+d[mIndex];}
            if (d[dIndex].length === 1) {d[dIndex] = '0'+d[dIndex];}
            
            // Validate that we've got a four digit year
            if (d[yIndex].length !== 4) {return false;}
            
            return Date.fromString(d.join('/'));
        },
        daysBetween: function(date1, date2) {
            var ONE_DAY = 24*60*60*1000;
            var _date1 = el8.service.tz.toTzDate(date1); // get rid of times
            var _date2 = el8.service.tz.toTzDate(date2);

            var diffMillis = Math.abs(_date1.getTime() - _date2.getTime());
            return Math.round(diffMillis / ONE_DAY);
        },
        minutesBetween: function(date1, date2) {
            var dateDiff = el8.service.tz.toTzDateTime(date1).getTime() - el8.service.tz.toTzDateTime(date2).getTime();
            return Math.floor((dateDiff/1000)/60);
        },

        // Date input processing
        processDateInput: function( str, defaultDate, showAlertFn ) {

            var today = el8.service.tz.today();
            var defaultDate = defaultDate || null;
            var showAlert = ( showAlert !== false ); // defaults to true

            var convertStrToNum = function(str) {
                str = str.toLowerCase();
                if( str === 'last' ) {
                    return -1;
                } else if( str === 'next' ) {
                    return 1;
                } else {
                    if( !isNaN(parseInt(str, 10)) ) {
                        return parseInt(str, 10);
                    } else if( el8.util.consts.NUM_LOOKUP[str] !== undefined ) {
                        return el8.util.consts.NUM_LOOKUP[str];
                    }
                }
                // Give up, return null
                return null;
            };

            var convertTwoDigitYear = function(str) {
                if (str.length !== 2) { return; }
                var forwardBuffer = 5;
                if (('20'+str)*1 > (today.getFullYear() + forwardBuffer)) {
                    return '19'+str;
                } else {
                    return '20'+str;
                }
            };

            // Allow for specific strings
            if( str.toLowerCase() === 'today' ) {
                return today;
            } else if( str.toLowerCase() === 'tomorrow' ) {
                return today.addDays(1);
            } else if( str.toLowerCase() === 'yesterday' ) {
                return today.addDays(-1);

            // Search for specific constructions
            } else {
                var strArray = str.toLowerCase().split(' ');

                // Search for specific time period terms; only want if index is 1 or higher
                if( strArray.indexOf('day') > 0 ) {
                    var num = convertStrToNum( strArray[strArray.indexOf('day')-1] );
                    if( num ) {
                        if (strArray.indexOf('ago') > 0) {
                            return today.addDays(-1*num);
                        } else {
                            return today.addDays(num);
                        }
                    }
                }
                if( strArray.indexOf('days') > 0 ) {
                    var num = convertStrToNum( strArray[strArray.indexOf('days')-1] );
                    if( num ) {
                        if (strArray.indexOf('ago') > 0) {
                            return today.addDays(-1*num);
                        } else {
                            return today.addDays(num);
                        }
                    }
                }
                if( strArray.indexOf('week') > 0 ) {
                    var num = convertStrToNum( strArray[strArray.indexOf('week')-1] );
                    if( num ) {
                        if (strArray.indexOf('ago') > 0) {
                            return today.addDays(-1*num*7);
                        } else {
                            return today.addDays(num*7);
                        }
                    }
                }
                if( strArray.indexOf('weeks') > 0 ) {
                    var num = convertStrToNum( strArray[strArray.indexOf('weeks')-1] );
                    if( num ) {
                        if (strArray.indexOf('ago') > 0) {
                            return today.addDays(-1*num*7);
                        } else {
                            return today.addDays(num*7);
                        }
                    }
                }
                if( strArray.indexOf('month') > 0 ) {
                    var num = convertStrToNum( strArray[strArray.indexOf('month')-1] );
                    if( num ) {
                        if (strArray.indexOf('ago') > 0) {
                            return today.addMonths(-1*num);
                        } else {
                            return today.addMonths(num);
                        }
                    }
                }
                if( strArray.indexOf('months') > 0 ) {
                    var num = convertStrToNum( strArray[strArray.indexOf('months')-1] );
                    if( num ) {
                        if (strArray.indexOf('ago') > 0) {
                            return today.addMonths(-1*num);
                        } else {
                            return today.addMonths(num);
                        }
                    }
                }
                if( strArray.indexOf('year') > 0 ) {
                    var num = convertStrToNum( strArray[strArray.indexOf('year')-1] );
                    if( num ) {
                        if (strArray.indexOf('ago') > 0) {
                            return today.addYears(-1*num);
                        } else {
                            return today.addYears(num);
                        }
                    }
                }
                if( strArray.indexOf('years') > 0 ) {
                    var num = convertStrToNum( strArray[strArray.indexOf('years')-1] );
                    if( num ) {
                        if (strArray.indexOf('ago') > 0) {
                            return today.addYears(-1*num);
                        } else {
                            return today.addYears(num);
                        }
                    }
                } 

                // Check for < monthname > YY or < monthname > YYYY (go to 1st of month)
                var year = strArray[1];
                var month = Date.monthNamesLookup[ strArray[0].toLowerCase() ];
                if( month !== undefined ) {
                    if( year.length === 2 ) { year = convertTwoDigitYear(year); }
                    if( year.length === 4 ) {
                        return el8.service.tz.newTzDate(year, month, 1);
                    }
                }

                var strArray = str.toLowerCase().split('/');

                // Allow for MM/DD/YY or MM/DD/YYYY or YYYY/MM/DD
                if( strArray.length >= 3 ) {
                    var year, month, day;
                    // Interpret field with length 4 or more as the "year" field (if index 0 or 2)
                    if( strArray[0].length >= 4 ) {
                        // Assume YYYY/MM/DD
                        year = strArray[0].substr(0,4);
                        month = strArray[1].substr(0,2) - 1; // Date constructor indexes months at 0
                        day = strArray[2].substr(0,2);
                    } else if( strArray[2].length >= 4 ) {
                        // Assume MM/DD/YYYY
                        month = strArray[0].substr(0,2) - 1; // Date constructor indexes months at 0
                        day = strArray[1].substr(0,2);
                        year = strArray[2].substr(0,4);
                    } else {
                        // Assume MM/DD/YY
                        month = strArray[0].substr(0,2) - 1; // Date constructor indexes months at 0
                        day = strArray[1].substr(0,2);
                        year = strArray[2].substr(0,4);
                    }
                    if( year.length === 2 ) { 
                        year = convertTwoDigitYear(year);
                    } // assume 2-digit years are this century
                    if( !isNaN( month ) && !isNaN( day ) && !isNaN( year ) && year.length === 4 ) {
                        return el8.service.tz.newTzDate(year, month, day);
                    }

                // NEW: Allow for YYYY/MM or MM/DD or MM/YYYY (go to 1st of month)
                } else if( strArray.length === 2 ) {
                    var year, month, day;
                    // Interpret field with length 4 or more as the "year" field
                    if( strArray[0].length >= 4 ) {
                        // Assume YYYY/MM
                        year = strArray[0].substr(0,4);
                        month = strArray[1].substr(0,2) - 1;
                        day = 1;
                    } else if( strArray[1].length >= 4 ) {
                        // Assume MM/YYYY
                        year = strArray[1].substr(0,4);
                        month = strArray[0].substr(0,2) - 1;
                        day = 1;
                    } else {
                        // Assume MM/DD
                        year = el8.service.tz.today().getFullYear(); // get current year
                        month = strArray[0].substr(0,2) - 1;
                        day = strArray[1].substr(0,2);
                    }
                    if( !isNaN( month ) && !isNaN( day ) && !isNaN( year ) ) {
                        return el8.service.tz.newTzDate(year, month, day);
                    }
                } else if (strArray.length === 1) {
                    if (strArray[0].length === 4) {
                        var year = parseInt(strArray[0], 10);
                        var currYear = el8.service.tz.today().getFullYear();
                        if (!isNaN(year) && year >= 1900 && year <= currYear) {
                            return el8.service.tz.newTzDate(year, 0, 1);
                        }
                    }
                }
            }
            if( showAlertFn ) {
                showAlertFn('The inputted date was not recognized. Please input date in "' + Date.format + '" format or using common strings like "1 week", "tomorrow", "2 months".');
            }
            return defaultDate;
        }
        
    };

})();
